module.exports = __webpack_public_path__ + "childcare.svg?fd8cc69a6553f1a30b4bdb24361491fd";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/childcare.svg
// module id = 110
// module chunks = 0